import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useScope } from "../../../container/SelectProjectCompanyContainer"
import Send from "../../communication"
import { setData } from "../../redux/app/Actions"
import { customToast } from "../../../components/Toast"

export const toRemoveDoubleQuoteArr = (array, key = "value") => {
  const removeDoubleQuote = Array.isArray(array) && array?.map(item => item[key]?.replace(/'/g, '').replace(/ /g, ''))
  const getIds = Array.isArray(removeDoubleQuote) && removeDoubleQuote?.map((item) => `'${item}'`).join(",") || ""
  return getIds
}

export const useDWOptions = (values, hasOnlyProjects = false) => {
  const dispatch = useDispatch()
  const dw = useSelector((state) => state.app.dw)
  const projects = useSelector((state) => state.app.projects)
  const currentRole = useSelector((state) => state.app.currentUserRole)
  const { scope, scopeType, projectsByScope } = useScope()
  const [loadingDw, setLoading] = useState(false)

  let projectsByManager = []

  if (projects && (currentRole === "USER_MANAGER" || currentRole === "USER_TEC")) {
    projectsByManager = projects.map((project) => ({
      value: project?.id,
      label: project?.description,
    }))
  }

  const reload = () => {
    dispatch(setData({ dw: undefined }))
  }

  let selectedScopeType = scopeType;
  let checkHasValuesByScopeType;

  if(!hasOnlyProjects) {
    selectedScopeType = values?.filterType?.value ? values?.filterType?.value : scopeType;
    checkHasValuesByScopeType = values?.scope ? `${toRemoveDoubleQuoteArr(values?.scope)}` : toRemoveDoubleQuoteArr([{ value: scope?.id }]);
  } else {
    checkHasValuesByScopeType = `${toRemoveDoubleQuoteArr(projectsByScope, "id")}`;
  }

  const loadData = async () => {
    let dw = []
    setLoading(true)
    try {
      const itemDW = await Send.get("/dw/data-options", `projects=${checkHasValuesByScopeType}&scopeType=${selectedScopeType}` )
      if (currentRole === "USER_MANAGER" || currentRole === "USER_TEC") {
        dw = { ...itemDW, projects: projectsByManager };
      } else {
        dw = { ...itemDW, projects: hasOnlyProjects ? values?.projects : values?.scope };
      }

      dispatch(setData({ dw }))
    } catch(error) {
      customToast("Erro ao buscar opções.", 'error');
      console.log("Error", error);
    }
      
    setLoading(false)
    return dw
  }

  useEffect(() => {
    if(selectedScopeType && checkHasValuesByScopeType && checkHasValuesByScopeType.length) {
      loadData();
    } else {
      reload();
    }
  }, [!dw, selectedScopeType, checkHasValuesByScopeType])

  return [dw, reload, loadingDw]
}


